module.exports = __webpack_public_path__ + "ee42dcc93837dcbcac3fa6d95fadbe21.fbx";